// src/lib/authConfig.ts
import {
  PublicClientApplication,
  LogLevel,
  type Configuration,
} from '@azure/msal-browser';

const CLIENT_ID = import.meta.env.VITE_CLIENT_ID || '9650dc34-3a1a-433d-9584-427e8479c8bc';
const TENANT_ID = import.meta.env.VITE_TENANT_ID || '21f1f637-ef46-4dab-9fca-0a2be1289fb7';
const REDIRECT_URI = import.meta.env.VITE_REDIRECT_URI || window.location.origin;

// Scope for calling the DevGPT backend API. Must match a scope exposed on the
// UI app registration under "Expose an API" (e.g. api://<clientId>/access_as_user).
export const apiScope =
  import.meta.env.VITE_API_SCOPE || `api://${CLIENT_ID}/access_as_user`;

const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    // D5 (Teams) — persist the interim auth request state in a cookie so the
    // redirect round-trip survives storage partitioning inside the Teams
    // webview (iframe). Harmless outside Teams; standard MSAL guidance for
    // embedded/iframe redirect flows. Not Teams SSO — plain interactive login.
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Sign-in request — prompts for basic profile.
export const loginRequest = {
  scopes: ['User.Read'],
};

// Token-acquisition request for calls into the DevGPT backend API.
// App Roles (DevGPT.Admin) ride along in the access token's roles claim.
export const apiRequest = {
  scopes: [apiScope],
};